import {storeToRefs} from 'pinia';
import {useEnvironmentStore} from './useEnvironmentStore';

export const createEnvironment = async () => {
  const environmentStore = useEnvironmentStore();
  const {environment} = storeToRefs(environmentStore);

  await environmentStore.loadGlobalConfig();

  return {
    install: () => {
      environmentStore.setEnv();

      if (environment.value.devMode && !localStorage.getItem('errors')) {
        localStorage.setItem('errors', 'true');
      }
    },
  };
};
